import {
	capitalizeFirstLetter,
	followTeams,
	NETWORK_RECIPIENTS_LABELS,
	type NetworkType,
	useIntl
} from '@capsicum/common';
import styled, { useTheme } from 'styled-components';

import { ListCard, Reversible } from '../../atoms';
import { ChevronRightIcon } from '../../icons';

export type AddRecipientCardProps = {
	network: NetworkType;
	onCardClick: () => void;
	testID?: string;
};

export const AddRecipientCard = ({ network, onCardClick, testID = 'add-recipient-card' }: AddRecipientCardProps) => {
	const { $t } = useIntl();
	const { colors } = useTheme();

	const texts = {
		addRecipientCardSubTitle: $t('withdrawal.recipientList.addRecipientCardSubTitle', {
			networkLabel: NETWORK_RECIPIENTS_LABELS[network]
		}),
		addRecipientCardTitle: $t('withdrawal.recipientList.addRecipientCardTitle', {
			network: capitalizeFirstLetter(NETWORK_RECIPIENTS_LABELS[network])
		})
	};

	return (
		<S.AddRecipientListCard testID={testID} onClick={onCardClick}>
			<ListCard.Start>
				<ListCard.Image
					optimized
					src={followTeams?.src}
					testID={testID + '-add-button'}
					onClick={onCardClick}
				/>
			</ListCard.Start>
			<ListCard.Content>
				<ListCard.Title>{texts.addRecipientCardTitle}</ListCard.Title>
				<ListCard.SubTitle>{texts.addRecipientCardSubTitle}</ListCard.SubTitle>
			</ListCard.Content>
			<ListCard.End>
				<Reversible>
					<ChevronRightIcon color={colors.icons.main.enabled} />
				</Reversible>
			</ListCard.End>
		</S.AddRecipientListCard>
	);
};

namespace S {
	export const AddRecipientListCard = styled(ListCard)`
		height: auto;
	`;
}
